export function getInstallmentText(data) {
  return `${data.length > 1 ? data.length - 1 : 1} installments @ $${
    data.installment
  }`
}
